/**
 * PATH: packages/api/src/formDataRequest.ts
 * FILE_ID: API-FORMDATA-REQUEST-001
 * PURPOSE: Keep FormData uploads as multipart bytes instead of JSON.
 * WHY: Axios stringifies FormData when Content-Type is application/json.
 */
import type { InternalAxiosRequestConfig } from 'axios'

/** Reused from: packages/api/src/workforce/client.ts (workforceApiClient.upload) */
export function releaseFormDataContentType(config: InternalAxiosRequestConfig): void {
  if (typeof FormData === 'undefined' || !(config.data instanceof FormData)) return
  config.headers.set('Content-Type', false)
}
